"use client";

import { useEffect } from "react";

/**
 * Scroll-driven reveal system.
 * IntersectionObserver toggles .in-view on [data-reveal] elements.
 */
export function ParallaxCircles() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            entry.target.classList.add("in-view");
            observer.unobserve(entry.target);
          }
        }
      },
      { threshold: 0.15 }
    );

    document.querySelectorAll("[data-reveal]").forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return null;
}
